import { NavLink } from 'react-router-dom'
import { useAuth } from '../lib/useAuth'

export function Sidebar() {
  const { user, logout } = useAuth()
  
  return (
    <aside className="sidebar">
      <div className="sidebar-header">
        <h1 className="sidebar-logo">DIGSAFE</h1>
        <span className="sidebar-subtitle">Admin</span>
      </div>
      
      <nav className="sidebar-nav">
        <NavLink to="/" className={({ isActive }) => `nav-item ${isActive ? 'active' : ''}`}>
          <span className="nav-icon">📊</span>
          <span className="nav-label">Dashboard</span>
        </NavLink>
        <NavLink to="/workers" className={({ isActive }) => `nav-item ${isActive ? 'active' : ''}`}>
          <span className="nav-icon">👷</span>
          <span className="nav-label">Workers</span>
        </NavLink>
        <NavLink to="/hotels" className={({ isActive }) => `nav-item ${isActive ? 'active' : ''}`}>
          <span className="nav-icon">🏨</span>
          <span className="nav-label">Hotels</span>
        </NavLink>
        <NavLink to="/codes" className={({ isActive }) => `nav-item ${isActive ? 'active' : ''}`}>
          <span className="nav-icon">🔑</span>
          <span className="nav-label">Codes</span>
        </NavLink>
      </nav>
      
      <div className="sidebar-footer">
        <p className="user-email">{user?.email}</p>
        <button className="btn-logout" onClick={logout}>Log out</button>
      </div>
    </aside>
  )
}
